import { store } from "../store";
import { sessionCheck } from "../session";

function sessionIntervalCheck() {
  window.setInterval(() => {
    const session = store.getState().session;
    const auth = store.getState().auth;
    const id = auth.profile?.user?.id;

    if (
      auth.loggedIn &&
      session.hasApprovedSession &&
      session.hasStartedSession &&
      session.sessionTokens[id] &&
      !session.checkSessionRequestActive
    ) {
      store.dispatch(sessionCheck({ sessionToken: session.sessionTokens[id], playerId: id }));
    }
  }, 60 * 1000);
}

export default sessionIntervalCheck;
